// Generated by GitHub Copilot
import React from "react";
import PropTypes from "prop-types";
import { Alert } from "react-bootstrap";
import ImpactTableRow from "./ImpactTableRow";
import styles from "./ImpactTableView.module.css";

/**
 * ImpactTableView - Container component for displaying impacts in a table format
 * Renders a header row and maps impacts to ImpactTableRow components
 */
function ImpactTableView({
  impacts,
  currentUserEmail,
  expandedRows,
  onToggleExpand,
  onEdit,
  onResolve,
  loading,
  error,
}) {
  // Handle loading state
  if (loading) {
    return (
      <div className={styles.loadingContainer}>
        <div
          className="spinner-border spinner-border-sm text-primary"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
        <span className={styles.loadingText}>Loading impact reports...</span>
      </div>
    );
  }

  // Handle error state
  if (error) {
    return (
      <Alert variant="warning" className="mb-0">
        {error}
      </Alert>
    );
  }

  // Handle empty state
  if (!impacts || impacts.length === 0) {
    return (
      <Alert variant="info" className="mb-0">
        No impact reports found. All impacts have been resolved or none have
        been reported.
      </Alert>
    );
  }

  return (
    <div className={styles.tableContainer}>
      {/* Table Header - Desktop Only */}
      <div className={styles.tableHeader}>
        <div className={styles.headerIconCell}></div>
        <div className={styles.headerStatusCell}>Status</div>
        <div className={styles.headerBrandCell}>Brand</div>
        <div className={styles.headerWorkloadCell}>Workload Name</div>
        <div>&nbsp;</div>
      </div>

      {/* Table Body */}
      <div className={styles.tableBody}>
        {impacts.map((impact) => (
          <ImpactTableRow
            key={impact.id}
            impact={impact}
            currentUserEmail={currentUserEmail}
            onEdit={onEdit}
            onResolve={onResolve}
            expanded={expandedRows.has(impact.id)}
            onToggleExpand={() => onToggleExpand(impact.id)}
          />
        ))}
      </div>

      {/* Summary Footer */}
      <div className={styles.tableFooter}>
        <small className={styles.footerText}>
          Showing {impacts.length} impact report
          {impacts.length !== 1 ? "s" : ""}
        </small>
      </div>
    </div>
  );
}

ImpactTableView.propTypes = {
  impacts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      status: PropTypes.string,
      applicationName: PropTypes.string,
      brand: PropTypes.string,
      ci: PropTypes.string,
      impactDescription: PropTypes.string,
      childIncidentNumber: PropTypes.string,
      createdAt: PropTypes.string,
      createdBy: PropTypes.string,
    }),
  ).isRequired,
  currentUserEmail: PropTypes.string,
  expandedRows: PropTypes.instanceOf(Set).isRequired,
  onToggleExpand: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onResolve: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  error: PropTypes.string,
};

ImpactTableView.defaultProps = {
  loading: false,
  error: null,
};

export default ImpactTableView;
